import { __assign } from "tslib";
import React from 'react';
import MediaItem from '../media/mediaItem';
import { optionsMap } from 'pro-gallery-lib';
var ThreeDItem = React.lazy(function () { return import(/* webpackChunkName: "ThreeDItem" */ './3dItem'); });
export default function ThreeDItemWrapper(props) {
    var options = props.options;
    var playTrigger = options[optionsMap.behaviourParams.item.threeDimensionalScene.playTrigger];
    var showVideoPlayButton = options[optionsMap.behaviourParams.item.threeDimensionalScene.enablePlayButton];
    return (React.createElement(MediaItem, __assign({}, props, { MediaImplementation: ThreeDItem, playTrigger: playTrigger, placeholderExtraClasses: ['gallery-item-3d-placeholder'], enableImagePlaceholder: true, showPlayButton: showVideoPlayButton })));
}
//# sourceMappingURL=3dItemWrapper.js.map